'use es6';

import { Record } from 'immutable';
const DEFAULTS = {
  id: 0,
  name: ''
};
export default class Criterion extends Record(DEFAULTS) {
  static fromJS({
    id,
    name
  }) {
    return new Criterion({
      id,
      name
    });
  }

}